import { React, useRef, useState } from "react";
import styles from "../style";
import Services from '../components/Services';
import Heroserv from "../components/Heroserv";
import Footer from "../components/Footer";
import Thesis from "../components/Thesis";
import FeatureCard from "../components/FeatureCard";
import slider from "../constants/slider";

const Expertise = () => {
  return (
    <div className="w-full ">
      <Heroserv />
      <FeatureCard slider={slider} className="py-10"/> 
      <Thesis />      
      <Footer />   
    </div>
  )
}
export default Expertise;